import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es6.object.assign.js";
import Vue from 'vue';
import QBtn from "../btn/QBtn.js";
import QInput from "../input/QInput.js";
import DarkMixin from "../../mixins/dark.js";
import ListenersMixin from "../../mixins/listeners.js";
import { btnDesignOptions, btnPadding, getBtnDesign } from "../../mixins/btn.js";
import { stop } from "../../utils/event.js";
import { between } from "../../utils/format.js";
import { isKeyCode } from "../../utils/private/key-composition.js";
import cache from "../../utils/private/cache.js";
function getBool(val, otherwise) {
  return [true, false].includes(val) ? val : otherwise;
}
export default Vue.extend({
  name: 'QPagination',
  mixins: [DarkMixin, ListenersMixin],
  props: {
    value: {
      type: Number,
      required: true
    },
    min: {
      type: [Number, String],
      default: 1
    },
    max: {
      type: [Number, String],
      required: true
    },
    maxPages: {
      type: [Number, String],
      default: 0,
      validator: function validator(v) {
        return (typeof v === 'string' ? parseInt(v, 10) : v) >= 0;
      }
    },
    inputStyle: [Array, String, Object],
    inputClass: [Array, String, Object],
    size: String,
    disable: Boolean,
    input: Boolean,
    iconPrev: String,
    iconNext: String,
    iconFirst: String,
    iconLast: String,
    toFn: Function,
    boundaryLinks: {
      type: Boolean,
      default: null
    },
    boundaryNumbers: {
      type: Boolean,
      default: null
    },
    directionLinks: {
      type: Boolean,
      default: null
    },
    ellipses: {
      type: Boolean,
      default: null
    },
    ripple: {
      type: [Boolean, Object],
      default: null
    },
    round: Boolean,
    rounded: Boolean,
    flat: Boolean,
    outline: Boolean,
    unelevated: Boolean,
    push: Boolean,
    glossy: Boolean,
    color: {
      type: String,
      default: 'primary'
    },
    textColor: String,
    activeDesign: {
      type: String,
      default: '',
      values: function values(v) {
        return v === '' || btnDesignOptions.includes(v);
      }
    },
    activeColor: String,
    activeTextColor: String,
    padding: {
      type: String,
      default: '3px 2px'
    }
  },
  data: function data() {
    return {
      newPage: null
    };
  },
  watch: {
    min: function min() {
      this.model = this.value;
    },
    max: function max() {
      this.model = this.value;
    }
  },
  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        val = parseInt(val, 10);
        if (this.disable || isNaN(val)) {
          return;
        }
        var value = between(val, this.__min, this.__max);
        this.$emit('input', value);
      }
    },
    inputPlaceholder: function inputPlaceholder() {
      return this.model + ' / ' + this.__max;
    },
    __min: function __min() {
      return parseInt(this.min, 10);
    },
    __max: function __max() {
      return parseInt(this.max, 10);
    },
    __maxPages: function __maxPages() {
      return parseInt(this.maxPages, 10);
    },
    __boundaryLinks: function __boundaryLinks() {
      return getBool(this.boundaryLinks, this.input);
    },
    __boundaryNumbers: function __boundaryNumbers() {
      return getBool(this.boundaryNumbers, !this.input);
    },
    __directionLinks: function __directionLinks() {
      return getBool(this.directionLinks, this.input);
    },
    __ellipses: function __ellipses() {
      return getBool(this.ellipses, !this.input);
    },
    __btnDesign: function __btnDesign() {
      return getBtnDesign(this, 'flat');
    },
    __btnActiveDesign: function __btnActiveDesign() {
      // we also reset non-active design
      var acc = _defineProperty({}, this.__btnDesign, false);
      if (this.activeDesign !== '') {
        acc[this.activeDesign] = true;
      }
      return acc;
    },
    icons: function icons() {
      var ico = [this.iconFirst || this.$q.iconSet.pagination.first, this.iconPrev || this.$q.iconSet.pagination.prev, this.iconNext || this.$q.iconSet.pagination.next, this.iconLast || this.$q.iconSet.pagination.last];
      return this.$q.lang.rtl === true ? ico.reverse() : ico;
    },
    attrs: function attrs() {
      var attrs = {
        role: 'navigation'
      };
      if (this.disable === true) {
        attrs['aria-disabled'] = 'true';
      }
      return attrs;
    },
    btnProps: function btnProps() {
      var _ref;
      return _ref = {}, _defineProperty(_ref, this.__btnDesign, true), _defineProperty(_ref, "round", this.round), _defineProperty(_ref, "rounded", this.rounded), _defineProperty(_ref, "padding", this.padding), _defineProperty(_ref, "color", this.color), _defineProperty(_ref, "textColor", this.textColor), _defineProperty(_ref, "size", this.size), _defineProperty(_ref, "ripple", this.ripple !== null ? this.ripple : true), _ref;
    },
    activeBtnProps: function activeBtnProps() {
      return _objectSpread(_objectSpread({}, this.__btnActiveDesign), {}, {
        color: this.activeColor || this.color,
        textColor: this.activeTextColor || this.textColor
      });
    },
    btnConfig: function btnConfig() {
      var maxPages = Math.max(this.__maxPages, 1 + (this.__ellipses ? 2 : 0) + (this.__boundaryNumbers ? 2 : 0));
      var acc = {
        pgFrom: this.__min,
        pgTo: this.__max,
        ellipsesStart: false,
        ellipsesEnd: false,
        boundaryStart: false,
        boundaryEnd: false,
        marginalStyle: {
          minWidth: "".concat(Math.max(2, String(this.__max).length), "em")
        }
      };
      if (this.__maxPages && maxPages < this.__max - this.__min + 1) {
        maxPages = 1 + Math.floor(maxPages / 2) * 2;
        acc.pgFrom = Math.max(this.__min, Math.min(this.__max - maxPages + 1, this.value - Math.floor(maxPages / 2)));
        acc.pgTo = Math.min(this.__max, acc.pgFrom + maxPages - 1);
        if (this.__boundaryNumbers) {
          acc.boundaryStart = true;
          acc.pgFrom++;
        }
        if (this.__ellipses && acc.pgFrom > this.__min + (this.__boundaryNumbers ? 1 : 0)) {
          acc.ellipsesStart = true;
          acc.pgFrom++;
        }
        if (this.__boundaryNumbers) {
          acc.boundaryEnd = true;
          acc.pgTo--;
        }
        if (this.__ellipses && acc.pgTo < this.__max - (this.__boundaryNumbers ? 1 : 0)) {
          acc.ellipsesEnd = true;
          acc.pgTo--;
        }
      }
      return acc;
    },
    inputEvents: function inputEvents() {
      var _this = this;
      var updateModel = function updateModel() {
        _this.model = _this.newPage;
        _this.newPage = null;
      };
      return {
        input: function input(val) {
          _this.newPage = val;
        },
        keyup: function keyup(e) {
          isKeyCode(e, 13) === true && updateModel();
        },
        blur: updateModel
      };
    }
  },
  methods: {
    set: function set(value) {
      this.model = value;
    },
    setByOffset: function setByOffset(offset) {
      this.model = this.model + offset;
    },
    __getBtn: function __getBtn(h, data, props, page, active) {
      var _this2 = this;
      data.props = _objectSpread(_objectSpread({}, this.btnProps), props);
      data.attrs = _objectSpread({
        'aria-label': page,
        'aria-current': 'false'
      }, data.attrs);
      if (active === true) {
        Object.assign(data.props, this.activeBtnProps);
        data.attrs['aria-current'] = 'true';
      }
      if (page !== void 0) {
        if (this.toFn !== void 0) {
          data.props.to = this.toFn(page);
        } else {
          data.on = {
            click: function click() {
              _this2.set(page);
            }
          };
        }
      }
      return h(QBtn, data);
    }
  },
  render: function render(h) {
    var contentStart = [];
    var contentEnd = [];
    var contentMiddle;
    if (this.__boundaryLinks === true) {
      contentStart.push(this.__getBtn(h, {
        key: 'bls'
      }, {
        disable: this.disable || this.value <= this.__min,
        icon: this.icons[0]
      }, this.__min));
      contentEnd.unshift(this.__getBtn(h, {
        key: 'ble'
      }, {
        disable: this.disable || this.value >= this.__max,
        icon: this.icons[3]
      }, this.__max));
    }
    if (this.__directionLinks === true) {
      contentStart.push(this.__getBtn(h, {
        key: 'bdp'
      }, {
        disable: this.disable || this.value <= this.__min,
        icon: this.icons[1]
      }, this.value - 1));
      contentEnd.unshift(this.__getBtn(h, {
        key: 'bdn'
      }, {
        disable: this.disable || this.value >= this.__max,
        icon: this.icons[2]
      }, this.value + 1));
    }
    if (this.input !== true) {
      // has buttons instead of inputbox
      contentMiddle = [];
      var _this$btnConfig = this.btnConfig,
        pgFrom = _this$btnConfig.pgFrom,
        pgTo = _this$btnConfig.pgTo,
        style = _this$btnConfig.marginalStyle;
      if (this.btnConfig.boundaryStart === true) {
        var active = this.__min === this.value;
        contentStart.push(this.__getBtn(h, {
          key: 'bns',
          style: style
        }, {
          disable: this.disable,
          label: this.__min
        }, this.__min, active));
      }
      if (this.btnConfig.boundaryEnd === true) {
        var _active = this.__max === this.value;
        contentEnd.unshift(this.__getBtn(h, {
          key: 'bne',
          style: style
        }, {
          disable: this.disable,
          label: this.__max
        }, this.__max, _active));
      }
      if (this.btnConfig.ellipsesStart === true) {
        contentStart.push(this.__getBtn(h, {
          key: 'bes',
          style: style
        }, {
          disable: this.disable,
          label: '…',
          ripple: false
        }, pgFrom - 1));
      }
      if (this.btnConfig.ellipsesEnd === true) {
        contentEnd.unshift(this.__getBtn(h, {
          key: 'bee',
          style: style
        }, {
          disable: this.disable,
          label: '…',
          ripple: false
        }, pgTo + 1));
      }
      for (var i = pgFrom; i <= pgTo; i++) {
        contentMiddle.push(this.__getBtn(h, {
          key: "bpg".concat(i),
          style: style
        }, {
          disable: this.disable,
          label: i
        }, i, i === this.value));
      }
    }
    return h('div', {
      staticClass: 'q-pagination row no-wrap items-center',
      class: {
        disabled: this.disable
      },
      attrs: this.attrs,
      on: _objectSpread({}, this.qListeners)
    }, [h('div', {
      staticClass: 'q-pagination__content row no-wrap items-center'
    }, [].concat(contentStart, [h('div', {
      staticClass: 'q-pagination__middle row justify-center',
      on: this.input === true ? cache(this, 'stop', {
        input: stop
      }) : null
    }, this.input === true ? [h(QInput, {
      staticClass: 'inline',
      style: {
        width: "".concat(this.inputPlaceholder.length / 1.5, "em")
      },
      props: {
        type: 'number',
        dense: true,
        value: this.newPage,
        disable: this.disable,
        dark: this.isDark,
        borderless: true,
        inputClass: this.inputClass,
        inputStyle: this.inputStyle
      },
      attrs: {
        placeholder: this.inputPlaceholder,
        min: this.__min,
        max: this.__max
      },
      on: _objectSpread({}, this.inputEvents)
    })] : contentMiddle)], contentEnd))]);
  }
});